import {
	ApplicationConfig,
	provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { AUTH_API_BASE_URL, AUTH_SUPABASE_CLIENT } from '@pressteaze/auth';
import { createBrowserSupabaseClient } from '@pressteaze/data-access';
import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
	providers: [
		provideBrowserGlobalErrorListeners(),
		provideRouter(appRoutes),
		provideHttpClient(),
		{
			provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
			useValue: { appearance: 'outline', subscriptSizing: 'dynamic' },
		},
		{
			provide: AUTH_API_BASE_URL,
			useValue: `${environment.supabaseUrl}/functions/v1`,
		},
		{
			provide: AUTH_SUPABASE_CLIENT,
			useFactory: () =>
				createBrowserSupabaseClient({
					url: environment.supabaseUrl,
					publishableKey: environment.supabasePublishableKey,
				}),
		},
	],
};
